
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A page of webhook attempts matching the specified criteria generated by a selected event.`}</p>
    <p>{`A maximum of 100 webhook attempts can be returned in a single page.
Additional webhook attempts can be queried using a pagination cursor.`}</p>
    <p>{`The result list is returned in ascending creation date & time order.
It starts from the earliest known attempt if no pagination arguments are provided.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;